import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../hocs/Layout";
import Confetti from "react-confetti";

function CheckoutSuccess() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sessionId = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState(null);
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    // Dispara confeti unos segundos
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000); // 5 segundos de confeti

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (sessionId) {
      // Llamar a tu endpoint para completar la orden
      fetch(`${process.env.REACT_APP_API_URL}/api/payment/complete-embedded/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId }),
      })
        .then((res) => res.json())
        .then((data) => {
          setResponseData(data);
          setLoading(false);
          console.log(data);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [sessionId]);

  return (
    <Layout products={true}>
      {/* Mostrar confeti solo mientras showConfetti sea true */}
      {showConfetti && <Confetti />}

      <div className="flex flex-col items-center justify-center min-h-screen relative bg-white overflow-hidden p-4">
        {loading ? (
          <div className="flex flex-col items-center">
            <svg
              className="animate-spin h-12 w-12 text-gray-600 mb-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />

              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              />
            </svg>
            <p className="text-xl text-gray-700">Procesando tu orden...</p>
          </div>
        ) : (
          <div className="max-w-xl text-center">
            <h1 className="text-3xl font-bold text-white mb-4">
              ¡Gracias por tu compra!
            </h1>
            <p className="text-white mb-6">
              {responseData?.success
                ? "Tu orden se ha creado satisfactoriamente. "
                : "Hubo un problema al crear tu orden o ya existía."}
            </p>
            <div className="w-32 h-32 mx-auto mb-6 flex items-center justify-center bg-white rounded-full">
              <svg
                className="w-16 h-16 text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <p className="text-sm text-gray-500">
              Puedes revisar el detalle de tu compra en tu correo sino puedes
              verificarlo revisa la carpeta SPAM.
            </p>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default CheckoutSuccess;
